<template>
    <span :class="{ 'truncate': truncate }">
        <template v-if="column === 'name'">
            <router-link
                class="flex items-center | group-hover:text-blue-500 | duration-200"
                :to="campaignLink"
            >
                <span>{{ campaign.name }}</span>
                <nio-icon
                    class="opacity-0 text-blue-500 ml-2 | group-hover:opacity-100 | transition-opacity duration-200"
                    name="bold/arrow-button-circle-right-1"
                />
            </router-link>
        </template>
        <template v-if="column === 'createdDate'">
            {{ createdAt }}
        </template>
        <template v-if="column === 'numberContacts'">
            {{ campaign.contacts_count }}
        </template>
        <template v-if="column === 'actions'">
            <nio-dropdown>
                <template #trigger>
                    <button class="link-gray text-base">
                        <nio-icon name="bold/navigation-menu-horizontal" />
                    </button>
                </template>

                <nio-dropdown-item
                    icon="regular/list-bullets-1"
                    tag="router-link"
                    :to="campaignLink"
                >
                    {{ $t('campaigns.listing.actions.manage') }}
                </nio-dropdown-item>
                <nio-dropdown-item
                    icon="regular/pencil-write"
                    @click="$emit('edit')"
                >
                    {{ $t('global.general.edit') }}
                </nio-dropdown-item>
                <nio-dropdown-item
                    class="hover:text-red-500"
                    divided-top
                    icon="regular/bin-2-alternate"
                    @click="$emit('delete')"
                >
                    {{ $t('global.general.delete') }}
                </nio-dropdown-item>
            </nio-dropdown>
        </template>
    </span>
</template>

<script>
    export default {
        props: {
            column: {
                type: String,
                required: true,
            },
            campaign: {
                type: Object,
                required: true,
            },
            truncate: {
                type: Boolean,
                default: true,
            },
        },

        computed: {
            createdAt() {
                return this.formatDateTime(this.campaign.created_at);
            },

            campaignLink() {
                return {
                    name: 'campaign',
                    params: {
                        id: this.campaign.id,
                    },
                };
            },
        },

        methods: {
            goToConversation() {
                if (!this.conversation) {
                    return;
                }

                this.$router.push({
                    name: 'chat',
                    params: {
                        id: this.conversation.id,
                    },
                });
            },
        },
    };
</script>
